var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "confirm-fade" } }, [
    _vm.isVisible
      ? _c(
          "div",
          {
            staticClass: "confirm-overlay",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                return _vm.onCancel.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "confirm-dialog",
                attrs: { role: "alertdialog", "aria-modal": "true" },
              },
              [
                _c("p", { staticClass: "confirm-message" }, [
                  _vm._v("\n        " + _vm._s(_vm.dialogMessage) + "\n      "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "confirm-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "confirm-btn confirm-btn--cancel",
                      on: { click: _vm.onCancel },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.dialogCancelText) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "confirm-btn confirm-btn--ok",
                      on: { click: _vm.onOk },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.dialogOkText) + "\n        "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }